import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'

const STREET_VIEW_UNAVAILABLE_COUNTRIES = [
  'CY',
  'LB',
  'SY',
  'IQ',
  'IR',
  'IL',
  'JO',
  'SA',
  'KW',
  'QA',
  'BH',
  'AE',
  'OM',
  'YE',
  'DZ',
  'AO',
  'BJ',
  'BW',
  'IO',
  'BF',
  'BI',
  'CV',
  'CM',
  'CF',
  'TD',
  'KM',
  'CG',
  'CD',
  'CI',
  'DJ',
  'EG',
  'GQ',
  'ER',
  'SZ',
  'ET',
  'TF',
  'GA',
  'GM',
  'GH',
  'GN',
  'GW',
  'KE',
  'LS',
  'LR',
  'LY',
  'MG',
  'MW',
  'ML',
  'MR',
  'MU',
  'YT',
  'MA',
  'MZ',
  'NA',
  'NE',
  'NG',
  'RE',
  'RW',
  'SH',
  'ST',
  'SN',
  'SC',
  'SL',
  'SO',
  'ZA',
  'SS',
  'SD',
  'TZ',
  'TG',
  'TN',
  'UG',
  'EH',
  'ZM',
  'ZW',
  'PK'
]

export const useIsStreetViewFeatureEnabled = (
  hotelCountry: string
): boolean => {
  const {search} = useBrandCapabilities()
  if (!hotelCountry || !search.hasStreetView) return false
  return !STREET_VIEW_UNAVAILABLE_COUNTRIES.includes(hotelCountry)
}
